<script setup>
import { ref, watch } from "vue";
import { BIconChevronDown, BIconChevronRight } from "bootstrap-icons-vue";

const props = defineProps({
  label: {
    type: String,
    default: "Select Option",
  },
  collapseId: {
    type: String,
    default: null,
  },
  collapsed: {
    type: Boolean,
    default: false,
  },
});

const isCollapsed = ref(props.collapsed);

const toggleCollapse = () => {
  isCollapsed.value = !isCollapsed.value;
};

watch(
  () => props.collapsed,
  (val) => {
    isCollapsed.value = val;
  },
);
</script>

<template>
  <div class="w-100 collapsible-component">
    <span
      @click="toggleCollapse"
      class="label-wrapper text-neutral-400 fw-bold d-flex justify-content-between align-items-center cursor-pointer"
    >
      <span>
        <BIconChevronDown v-if="isCollapsed" />
        <BIconChevronRight v-else />
        <span class="ms-2 font-size-sm">{{ label }}</span>
      </span>
      <slot name="content-label-right" />
    </span>

    <b-collapse v-model="isCollapsed" :id="collapseId">
      <slot />
    </b-collapse>
  </div>
</template>
